type RemoveCookie = (name: string, options?: { path?: string; domain?: string }) => void;

const clearDeeplinkExitState = (removeCookie?: RemoveCookie) => {
  window.sessionStorage.removeItem("deeplinkTk");
  removeCookie?.("STATE", { path: "/" });
  removeCookie?.("OFFER", { path: "/subscriptionplus" });
  removeCookie?.("PARTNER", { path: "/subscriptionplus" });
};

export default clearDeeplinkExitState;
